<template>
  <section>
    <a class="anchor" id="results"></a>
    <h2 class="title">{{$t('results')}}<div class="links"><a class="link" target="_blank" :href="`${publicPath}static/男子個人歴代記録.pdf`">{{$t('mLifetimeRecords')}} <i class="fa fa-download"></i></a><a class="link" target="_blank" :href="`${publicPath}static/女子個人歴代記録.pdf`">{{$t('fLifetimeRecords')}} <i class="fa fa-download"></i></a></div></h2>
    <div class="parent-table">
        <b-table
        id="results-table"
        :data="records"
        :bordered="isBordered"
        :striped="isStriped"
        :narrowed="isNarrowed"
        :hoverable="isHoverable"
        :loading="isLoading"
        :focusable="isFocusable"
        :mobile-cards="hasMobileCards"
        per-page="8"
        paginated>
            <template slot-scope="props">
            <b-table-column  field="name" :label="$t('name')" searchable>
                {{props.row.name}}
            </b-table-column>
            <b-table-column  field="competition" :label="$t('competition')" searchable>
                {{props.row.competition}}
            </b-table-column>
            <b-table-column  field="place" :label="$t('place')" searchable>
                {{props.row.place}}
            </b-table-column>
            <b-table-column  field="date" :label="$t('date')" centered searchable search-place-holder="hey">
                {{props.row.date}}
            </b-table-column>
            <b-table-column  field="style" :label="$t('style')" centered searchable>
                {{props.row.style}}
            </b-table-column>
            <b-table-column field="record" :label="$t('record')">
                {{props.row.record}}
            </b-table-column>
            <b-table-column field="rank" :label="$t('rank')">
                {{props.row.rank}}
            </b-table-column>
            <b-table-column width="100" field="remark" :label="$t('remark')">
                {{props.row.remark}}
            </b-table-column>
            </template>
            <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon
                                    icon="emoticon-sad"
                                    size="is-large">
                                </b-icon>
                            </p>
                            <p>Nothing here.</p>
                        </div>
                    </section>
                </template>
        </b-table>
    </div>
    
  </section>
</template>

<script>
import db from '@/db/index'
export default {
        data() {
            return {
                publicPath: process.env.BASE_URL,
                records: [],
                isEmpty: false,
                isBordered: false,
                isStriped: false,
                isNarrowed: false,
                isHoverable: false,
                isFocusable: false,
                isLoading: false,
                hasMobileCards: false
            }
        },
        created() {
            var self = this;
            db.getDatabase().ref("records").once('value').then(function(snap){
                self.records = snap.val();
            });
        },
        mounted() {
            this.$nextTick(function () {
                Array.from(document.querySelectorAll("table input")).forEach(el=>{el.setAttribute("placeholder",this.$t('search'))});
            });
        },
        updated() {
            this.$nextTick(function () {
                Array.from(document.querySelectorAll("table input")).forEach(el=>{el.setAttribute("placeholder",this.$t('search'))});
            });
        }
    }
</script>

<style scoped>
@media only screen and (max-width: 1250px){
    .parent-table {
    overflow-x: auto;
    }
    #results-table {
    min-width: 950px;
    }
}
section {
    padding: 70px 10%;  
}
.link {
    font-size: 1rem;
    padding: 1px 4px;
    border-right: 2px solid;
  }
  .link:last-child {
    border-right: none;
    margin-right: 0;
  }
  .links {
    font-size: 1rem;
    padding-top: 10px;
    display: block;
  }
</style>